import React, { useState } from 'react';
import styles from './GovernorateHeatmap.module.css';

function cellColor(count, max) {
    if (count === 0 || max === 0) return 'transparent';
    const ratio = count / max;
    // interpolate: low → #0e4f5c  mid → #00a8c8  high → #00d9ff
    if (ratio < 0.25)  return `rgba(0, 217, 255, ${0.12 + ratio * 1.2})`;
    if (ratio < 0.55)  return `rgba(0, 217, 255, ${0.35 + ratio * 0.6})`;
    if (ratio < 0.80)  return `rgba(0, 217, 255, ${0.60 + ratio * 0.35})`;
    return `rgba(0, 217, 255, ${0.82 + ratio * 0.18})`;
}

function textColor(count, max) {
    if (count === 0) return '#334155';
    return count / max > 0.55 ? '#0f172a' : '#ffffff';
}

export default function GovernorateHeatmap({ data }) {
    const [tooltip, setTooltip] = useState(null);

    if (!data?.governorates?.length) return null;

    const { weeks, governorates } = data;
    const allCounts = governorates.flatMap((g) => g.counts);
    const max = Math.max(...allCounts, 1);

    return (
        <div className={styles.wrapper}>
            <div className={styles.scroll}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th className={styles.cornerCell} />
                            {weeks.map((w, i) => (
                                <th key={i} className={styles.weekHeader}>{w}</th>
                            ))}
                            <th className={styles.totalHeader}>الإجمالي</th>
                        </tr>
                    </thead>
                    <tbody>
                        {governorates.map((gov, gi) => {
                            const total = gov.counts.reduce((a, b) => a + b, 0);
                            return (
                                <tr key={gi} className={styles.row}>
                                    <td className={styles.govName}>{gov.name}</td>
                                    {gov.counts.map((count, wi) => (
                                        <td
                                            key={wi}
                                            className={styles.cell}
                                            style={{
                                                background: cellColor(count, max),
                                                color: textColor(count, max),
                                            }}
                                            onMouseEnter={(e) => setTooltip({
                                                text: `${gov.name} — الأسبوع ${weeks[wi]}: ${count} احتجاج`,
                                                x: e.clientX,
                                                y: e.clientY,
                                            })}
                                            onMouseLeave={() => setTooltip(null)}
                                        >
                                            {count > 0 ? count : ''}
                                        </td>
                                    ))}
                                    <td className={`${styles.cell} ${styles.totalCell}`}>
                                        {total > 0 ? total : '—'}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Color scale legend */}
            <div className={styles.legend}>
                <span className={styles.legendLabel}>أقل</span>
                <div className={styles.legendBar} />
                <span className={styles.legendLabel}>أكثر</span>
            </div>

            {/* Tooltip */}
            {tooltip && (
                <div
                    className={styles.tooltip}
                    style={{ top: tooltip.y - 40, left: tooltip.x + 12 }}
                >
                    {tooltip.text}
                </div>
            )}
        </div>
    );
}
